import { Avatar } from '@mui/material';
import classNames from 'classnames';
import React, { memo } from 'react';
import css from './Avatar.module.scss';

interface ComponentProps {
    /**
     * Will display an image in the avatar
     */
    imageSrc?: string;
    /**
     * Will display the letters in the avatar
     */
    letters?: string;
    /**
     * Size of the avatar. Default 'normal'
     */
    size?: 'normal' | 'large';
}

export const GMAvatar: React.FC<ComponentProps> = memo(({ size = 'normal', ...props }) => {
    return (
        <Avatar
            src={props.imageSrc}
            className={classNames(css.root, size === 'large' ? css.large : '')}
        >
            {props.letters}
        </Avatar>
    );
});